import React, { useState, useEffect, useRef } from "react";

export default function FancySelect({
  label,
  value,
  onChange,
  options,
  placeholder = "Select...",
  disabled = false,
  className = "",
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedLabel =
    options.find((opt) => String(opt.value) === String(value))?.label || "";

  return (
    <div className={`relative w-full ${className}`} ref={ref}>
      {label && (
        <label className="text-[12px] text-[#686873] block pb-1">
          {label}
        </label>
      )}

      {/* Main dropdown button */}
      <button
        type="button"
        disabled={disabled}
        onClick={() => !disabled && setOpen((prev) => !prev)}
        className={`
          w-full flex items-center justify-between
          border-b border-[#DCDCDF] text-left
          text-[16px]
          ${disabled ? "text-gray-400 cursor-not-allowed" : "text-black"}
          bg-transparent
          py-2
        `}
      >
        <span className={selectedLabel ? "" : "text-[#A7A7A7]"}>
          {selectedLabel || placeholder}
        </span>
        <span
          className={`
            w-3 h-3 border border-[#686873] border-t-0 border-l-0 rotate-45
            transition-transform
            ${open ? "rotate-[225deg] mt-1" : "-mt-1"}
          `}
        />
      </button>

      {/* Options list */}
      {open && (
        <div
          className="
            absolute left-0 mt-1 w-full bg-white
            border border-[#F2F2F2] rounded-lg shadow-lg z-30
            max-h-60 overflow-y-auto
          "
        >
          {options.length === 0 && (
            <div className="px-4 py-2 text-[14px] text-[#98999A]">
              No options available
            </div>
          )}

          {options.map((opt) => (
            <button
              key={opt.value}
              type="button"
              onClick={() => {
                onChange(opt.value);
                setOpen(false);
              }}
              className={`
                w-full flex items-center justify-between
                px-4 py-2 text-[15px]
                ${
                  String(value) === String(opt.value)
                    ? "bg-[#F0F5F0] text-[#0F0F0F]"
                    : "text-[#101010]"
                }
                hover:bg-[#F7F9FA]
              `}
            >
              <span className="text-left">{opt.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
